package org.example.project.service

import kotlinx.serialization.Serializable
import org.example.project.utils.All

@Serializable
data class YardDocumentSnapshot(
    val schemaVersion: Int = 1,
    val dokumentTyp: String,
    val layoutKey: String,
    val erstelltAm: String,
    val erstelltUm: String,
    val auftrag: All,
    val unternehmen: All = All(),
    val vorgangslog: List<All> = emptyList(),
    val kontrollDefinitionen: List<All> = emptyList(),
    val webKontrolle: All? = null,
    val logoSrc: String = "",
    val ausstellerSignatur: String = "",
    val ausstellerName: String = "",
    val fahrerSignatur: String = "",
    val fahrerName: String = ""
)

@Serializable
data class YardDocumentSnapshotSaveRequest(
    val pdfFileName: String,
    val snapshot: YardDocumentSnapshot
)
